import { Checkbox, FormControlLabel, Stack, Typography } from '@vapor/material'
import { useCallback, useState } from 'react'
import { i18n } from 'i18next'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'
import { useTranslation } from 'react-i18next'

export type PrivacyConsent =
  | {
      consent: true
      date: Date
    }
  | {
      consent: false
    }

export type PrivacyConsentCheckboxProps = {
  value?: { consent: boolean; date?: Date }
  onChange?: (value: PrivacyConsent) => void
  label?: string
  i18n?: i18n
  disabled?: boolean
}

function PrivacyConsentCheckbox(props: PrivacyConsentCheckboxProps) {
  const formatDate = useFormatDate()
  const { t } = useTranslation()
  const { value, onChange, label, i18n, disabled } = props
  const [localValue, setLocalValue] = useState<PrivacyConsent>(value ? { consent: value.consent, date: value.date ?? new Date() } : { consent: false })

  const onLocalChange = useCallback(
    (consent: boolean) => {
      const newLocalValue: PrivacyConsent = consent
        ? {
            consent: true,
            date: new Date(),
          }
        : {
            consent: false,
          }

      if (!value && JSON.stringify(newLocalValue) !== JSON.stringify(localValue)) {
        setLocalValue(newLocalValue)
        onChange?.(newLocalValue)
      }
      if (value && JSON.stringify(newLocalValue) !== JSON.stringify(value)) {
        setLocalValue(newLocalValue)
        onChange?.(newLocalValue)
      }
    },
    [value, onChange, localValue],
  )

  return (
    <FormControlLabel
      sx={{ alignItems: 'start' }}
      control={<Checkbox sx={{ paddingTop: 0 }} checked={localValue.consent} disabled={disabled} onChange={(event, checked) => onLocalChange(checked)} />}
      label={
        <Stack>
          {label && <Typography>{label}</Typography>}
          {localValue.consent && <Typography variant="filedText">{t('pms.common.customer.privacy_set_on', { formattedDate: formatDate(localValue.date) })}</Typography>}
        </Stack>
      }
    />
  )
}

export default PrivacyConsentCheckbox
